import http from '../../../../../lib/http'
import { unmapGoal } from '../../../../../lib/Proxy/goal.js'

export const GOALS = 'GOALS'
export const GOALS_SUCCESS = 'GOALS_SUCCESS'
export const GOALS_FAILURE = 'GOALS_FAILURE'

function goals () {
  return {
    type: GOALS
  }
}

function success (data) {
  return {
    type: GOALS_SUCCESS,
    questionnaireResponse: data
  }
}

function failure (error) {
  return {
    type: GOALS_FAILURE,
    error
  }
}

export const getGoals = () => (dispatch, getState) => {
  const {
    globalVars: {
      params: { id: patientId }
    }
  } = getState()
  dispatch(goals())
  return http
    .getRequest(
      `/patients/${patientId}/fhir/Goal?patient=Patient/${patientId}&category=160786009&_count=99999`
    )
    .then(response =>
      Promise.resolve({
        goals: (response.entry || []).map(e => unmapGoal(e.resource || {}))
      }))
    .then(data => dispatch(success(data)))
    .catch(err => dispatch(failure(err)))
}
